import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./tab-panel.css?inline";

@customElement("eko-tab-panel")
class TabPanel extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean, attribute: "no-padding-bottom" })
  noPaddingBottom: boolean = false;

  render() {
    return html`<div class="eko-tab-panel" part="root" role="tabpanel">
      <slot></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-tab-panel": TabPanel;
  }
}

export default TabPanel;
